import React from 'react';
import { FiChevronDown } from 'react-icons/fi';

/**
 * Select Component
 * Reusable select dropdown with label and error message
 */
const Select = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  options = [],
  error,
  touched,
  required = false,
  disabled = false,
  placeholder = 'Select an option',
  helper,
  className = '',
  selectClassName = '',
  ...props
}) => {
  const hasError = touched && error;
  const selectId = props.id || `select-${name}`;

  return (
    <div className={`mb-4 ${className}`}>
      {/* Label */}
      {label && (
        <label htmlFor={selectId} className="label">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      {/* Select wrapper */}
      <div className="relative">
        <select
          id={selectId}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          required={required}
          className={`
            ${hasError ? 'input-error' : 'input'}
            ${disabled ? 'bg-bukawa-gray-100 cursor-not-allowed' : ''}
            appearance-none pr-10
            ${selectClassName}
          `.trim().replace(/\s+/g, ' ')}
          aria-invalid={hasError ? 'true' : 'false'}
          aria-describedby={
            hasError ? `${selectId}-error` : helper ? `${selectId}-helper` : undefined
          }
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </option>
          ))}
        </select>

        {/* Chevron icon */}
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-bukawa-gray-400">
          <FiChevronDown className="h-5 w-5" />
        </div>
      </div>

      {/* Helper text */}
      {helper && !hasError && (
        <p
          id={`${selectId}-helper`}
          className="mt-1 text-sm text-bukawa-gray-500"
        >
          {helper}
        </p>
      )}

      {/* Error message */}
      {hasError && (
        <p
          id={`${selectId}-error`}
          className="mt-1 text-sm text-red-600"
          role="alert"
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default Select;